import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import authService from '../../services/AuthService';
import configuration from '../../config/Configuration';

let baseURL = configuration.apiUrlV2;
export const apiBaseURL = baseURL;

/****** RESOURCES APIS ***/

// request interceptor
const axiosRequestInterceptor = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    let accessToken: string | undefined;
    try {
        accessToken = await authService.getAccessToken();
    } catch (error) {
        accessToken = undefined;
    }

    return Promise.resolve({
        ...config,
        headers: {
            Authorization: accessToken ? `Bearer ${accessToken}` : null,
            ...config.headers,
        },
    });
};

/*** COMMON API ***/

// config
const apiAxiosConfig: AxiosRequestConfig = {
    baseURL: apiBaseURL,
};

// create axios http client
const apiAxiosV2: AxiosInstance = axios.create(apiAxiosConfig);
apiAxiosV2.interceptors.request.use(axiosRequestInterceptor);
export default apiAxiosV2;
